import type { CommentType } from '~/interfaces/comment';
import type { Subscription } from '~/interfaces/subscriptions';

import CommentAction from './CommentAction';

interface Props {
  comment: CommentType;
  postId: string;
  subscription?: Subscription;
  onSuccessfulReply: (newComment: any) => void;
  isPremiumCommentsOnly?: boolean;
}

const ReplyAction = ({ comment, postId, subscription, onSuccessfulReply, isPremiumCommentsOnly = false }: Props) => {
  return (
    <CommentAction
      postId={postId}
      commentId={comment.id}
      rows={3}
      isPremiumCommentsOnly={isPremiumCommentsOnly}
      onCommentCreated={(newComment) => {
        onSuccessfulReply(newComment);
      }}
      subscription={subscription}
    />
  );
};

export default ReplyAction;
